import React from "react";

/**
 * Reemplazo local de `react-c2c` (copy to clipboard): ese paquete quedó clavado en
 * peer react ^15/^16 y rompe el `npm ci` desde que subimos a React 18.
 *
 * Misma API que usábamos: <C2C text={...} render={({copied, handleClick}) => ...} />
 */
export class C2C extends React.Component {
  state = { copied: false };

  componentWillUnmount() {
    clearTimeout(this.timer);
  }

  copiar = async (text) => {
    // navigator.clipboard sólo existe en contextos seguros (https o localhost);
    // en el resto caemos al textarea + execCommand de toda la vida.
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      return;
    }
    const ta = document.createElement("textarea");
    ta.value = text;
    ta.style.position = "fixed";
    ta.style.opacity = "0";
    document.body.appendChild(ta);
    ta.select();
    document.execCommand("copy");
    document.body.removeChild(ta);
  };

  handleClick = async () => {
    const { text, onCopy } = this.props;
    try {
      await this.copiar(String(text));
      this.setState({ copied: true });
      if (onCopy) onCopy(text);
      clearTimeout(this.timer);
      this.timer = setTimeout(() => this.setState({ copied: false }), 3000);
    } catch (e) {
      this.setState({ copied: false });
    }
  };

  render() {
    return this.props.render({
      copied: this.state.copied,
      handleClick: this.handleClick,
    });
  }
}

export default C2C;
